/**
 * SSOT לתצוגת מחיר חדר: אותה לוגיקה כמו RoomsSelector (עמלת טיפול + אשראי + תצוגה).
 */

import { ldsOurTotalFareDisplayNis } from "../ldsVacationPackageDisplayPrice.js";
import { formatUsdDisplayInteger } from "../ceilUsd.js";

/**
 * תואם ל־RoomsSelector.calculateDisplayPrice — עיגול לסנטים (לא ceil).
 */
export function applyHandlingAndCreditCardFeesToIls(price, ctx) {
  const {
    handleFeeData,
    numberOfRooms,
    getCreditCardFeePercent,
    vacationPackagesPerRoomFixedMarkup,
    perRoomFixedMarkupIls,
  } = ctx || {};
  let result = Number(price);
  if (!Number.isFinite(result)) result = 0;
  try {
    if (handleFeeData?.type === "%") {
      result =
        Math.round((result + (result * handleFeeData.value) / 100) * 100) /
        100;
    } else if (handleFeeData?.type === "+") {
      const add =
        vacationPackagesPerRoomFixedMarkup === true &&
        perRoomFixedMarkupIls != null &&
        Number.isFinite(Number(perRoomFixedMarkupIls))
          ? Math.round(Number(perRoomFixedMarkupIls) * 100) / 100
          : Math.round(
              ((handleFeeData.value || 0) / (numberOfRooms || 1)) * 100
            ) / 100;
      result = result + add;
    }
  } catch {
    result = Number(price) || 0;
  }
  const creditCardFee =
    Math.round(
      ((parseFloat(result) * (getCreditCardFeePercent?.() || 0)) / 100) *
        100
    ) / 100;
  result = Math.round((result + creditCardFee) * 100) / 100;
  return result;
}

/**
 * תואם ל־RoomsSelector.getRoomPriceInIls — בלי resolveLdsRoomPriceWithCommissionForDisplay (אין seqNum בהוספת חדרים).
 */
export function getFinalIlsFromOurTotalFareForDisplay(tf, ctx) {
  if (!tf) return null;
  const applyFees = (base) =>
    applyHandlingAndCreditCardFeesToIls(base, ctx);

  const pwcNative = Number(tf.priceWithCommission) || 0;
  const ssotNis = ldsOurTotalFareDisplayNis(tf);

  /** כרטיסי "הוסף חדר" בחבילות: בסיס=LDS לפני שכבת עמלת סוכן בפיקר; חייבים לא ליצא מראש מ־priceWithCommissionAndCreditCardFee */
  const vpFixedMarkupPreview =
    ctx?.vacationPackagesPerRoomFixedMarkup === true &&
    ctx?.handleFeeData?.type === "+";
  if (vpFixedMarkupPreview && pwcNative > 0) {
    return applyFees(pwcNative);
  }

  if (pwcNative <= 0 && ssotNis > 0) {
    return applyFees(ssotNis);
  }

  if (pwcNative <= 0) {
    return null;
  }

  let priceInIls = tf.priceWithCommissionAndCreditCardFee;
  if (!priceInIls) {
    const priceWithHandleFee = tf.priceWithHandleFee;
    if (priceWithHandleFee) {
      const creditCardFeePercent = ctx?.getCreditCardFeePercent?.() || 0;
      const creditCardFee =
        Math.round(((priceWithHandleFee * creditCardFeePercent) / 100) * 100) /
        100;
      priceInIls = Math.round((priceWithHandleFee + creditCardFee) * 100) / 100;
    } else {
      priceInIls = applyFees(pwcNative);
    }
  }
  return typeof priceInIls === "number" ? priceInIls : null;
}

/**
 * תצוגת ₪ / $ כמו RoomsSelector (Math.round שקלים, ilsToUsd + formatUsdDisplayInteger לדולר שלם).
 */
export function formatRoomIlsUsdDisplay(finalIls, ilsToUsd, formatUsdFn = formatUsdDisplayInteger) {
  if (finalIls == null || !Number.isFinite(Number(finalIls))) {
    return {
      finalIls: null,
      ilsDisplayRounded: null,
      usdRaw: 0,
      usdDisplayIntegerStr: null,
    };
  }
  const ilsNum = Number(finalIls);
  const usdRaw = ilsToUsd ? Number(ilsToUsd(ilsNum)) : 0;
  const usdDisplayIntegerStr =
    Number.isFinite(usdRaw) && usdRaw > 0 && typeof formatUsdFn === "function"
      ? formatUsdFn(usdRaw)
      : null;
  return {
    finalIls: ilsNum,
    ilsDisplayRounded: Math.round(ilsNum),
    usdRaw,
    usdDisplayIntegerStr,
  };
}
